import { IPropertyChild } from 'components/property-editors/utils/ProviderNodeUtils';
import { DataAttributeProps, getDataAttributes } from 'utils/DataAttributeUtils';

/**
 *
 * @param path to convert to data attribute
 */
export function getDataPath(path: string[]) {
  return `[${path.join(',')}]`;
}

export function getDataLabel(editor: IPropertyChild) {
  return editor.Node.DisplayLabel;
}

export function getEditorDataAttributeProps(editor: IPropertyChild, path: string[]): DataAttributeProps {
  return {
    dataLabel: getDataLabel(editor),
    dataPath: getDataPath(path),
  };
}

export function getEditorDataAttributes(editor: IPropertyChild, path: string[]) {
  return getDataAttributes(getEditorDataAttributeProps(editor, path));
}
